export type PageInfoType = {
  pageId: string; // 페이지 아이디 (UUID 사용, 마운트 후 언마운트 시 업데이트) / Page ID (UUID used, updates on mount and unmount)
  pageName: string; // 페이지 이름 / Page name
};

export type AbTestTypeInfo = {
  phase: number; // A/B 테스트의 단계 구분 / Phase separation for A/B testing
  variant: string; // A/B 테스트의 변형 구분 / Variant separation for A/B testing
};

export type DeviceInfoType = {
  deviceId: string; // 디바이스 UUID (스토리지에 존재하면 사용, 없으면 생성) / Device UUID (Use from storage if exists, otherwise generate)
  deviceOs: string; // 디바이스 운영체제 / Device operating system
};

export type UserInfoType = {
  interest?: string; // 유저가 처음 가입할때 누른 버튼
  gender_type?: 'male' | 'female' | ''; // 유저 성별
  age_group?: string; // birthday 값
  subscription_status?: string;
};

export type DefaultLogParamsType = {
  deviceInfo: DeviceInfoType; // 디바이스 정보 / Device information
  action: CombinedActionEnum; // 로그 액션 / Log action
  pageInfo: PageInfoType; // 페이지 정보 / Page information
  abTestInfo?: AbTestTypeInfo; // A/B 테스트 정보 (선택적) / A/B test info (optional)
  userInfo?: UserInfoType; // 파어이베이스내에 유저 구분을 위한 데이터
  extraParameter?: string | number; // 추가 구분값 들어가는 경우
  deepLinkSource: string; // 딥링크로 접근한 소스들
};

// 페이지 이벤트 / Page Events
export enum AnalyticsPageActionEnum {
  MOUNTED = 'page.mounted', // 페이지 마운트 시 / When the page is mounted
  UNMOUNTED = 'page.unmounted', // 페이지 언마운트 시 / When the page is unmounted
  FOCUS = 'page.focus', // 페이지가 포커스를 받을 때 / When the page gains focus
  FOCUS_OUT = 'page.focus-out', // 페이지에서 이동할 때 / When leaving the page
  ACTIVE = 'page.active', // 백그라운드에서 다시 돌아올 때 / When returning from background
  BACKGROUND = 'page.background', // 백그라운드로 이동할 때 / When moving to background
}

// 플레이어 클릭 이벤트 옵션
export enum AnalyticsPlayerOptionEnum {
  HEART = 'heart', //하트 클릭
  INFORMATION = 'information', // 정보 클릭
  REPLY = 'reply', // 댓글 클릭
  TIMER = 'timer', // 타이머 클릭
  OFFLINE = 'offline', // 오프라인 저장 클릭
}

// 유저 액션 / User Actions
export enum UserActionEnum {
  LOGIN = 'login', // 로그인 / Login
  SIGNUP = 'signup', // 회원가입 / Signup
  CLICK_PLAYER_OPTIONS = 'player_options_click_event', //플레이어 안에서 옵션 클릭
  HOME_SUBSCRIPTION_CLICK = 'home_subscription_click_event', // 홈 화면에서 구독 유도 버튼 클릭 이벤트
  CATEGORY_MAIN_PLAY_BUTTON = 'category_main_play_button', // 카테고리 안에서 main 플레이버튼 누른 이벤트
  SOUND_EFFECT_INTRO_BUTTON = 'sound_effect_intro_button', // 효과보기 누른 버튼 횟수
  DEEP_LINK_OPEN = 'deep_link_open' // 딥링크 오픈시 호출 
}

export enum SubscriptionActionEnum {
  MONTHLY = 'monthly_subscription',
  ANNUAL = 'annual_subscription',
}

// 이벤트 타입 통합 / Combined event type for future scalability
export type CombinedActionEnum = AnalyticsPageActionEnum | UserActionEnum | SubscriptionActionEnum;

// 애널리틱스 API 출력 타입 / Analytics API output type
export type AnalyticsApiOutputType = {
  action: CombinedActionEnum; // 수행된 액션 / Performed action
  pageName: string; // 페이지 이름 / Page name
  pageId: string; // 페이지 ID / Page ID
  deviceId: string; // 디바이스 ID / Device ID
  deviceInfo: DeviceInfoType; // 디바이스 정보 / Device information
  variant?: string; // A/B 테스트 변형 / A/B test variant
  phase?: number; // A/B 테스트 단계 / A/B test phase
};

// 딥링크 유입시 asyncStorage에 저장 후 firebase에 이벤트마다 전송 
export const DEEP_LINK_SOURCE = 'deep_link_source'